export const stateIds = {
    'normal': 1,
    'missing': 2,
    'crown': 9,
    'implantOnePhase': 10,
    'implant': 11,
    'healingScrew': 12,
    'abutment': 13,
    'bridge': 15,
    'worn': 16,
    'filed': 19,
};
